module.exports = __webpack_public_path__ + "media/Images/resources-hero-001-30cff11d526d4e56be902861293c56fc.jpg";